export enum MileageOptionsEnum {
    LessThan60Miles = 1,
    VirtualObservation = 2,
    GreaterThan90Miles = 3,
    Between60And90Miles = 4
}